import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createMemoStyles, safeRest, deprecate, isControlled, uniqueId } from '@wds/utils';
import { useTheme } from 'react-jss';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var SIZES = /* #__PURE__ */Object.freeze(['lg', 'md', 'sm']);
/* #__PURE__ */Object.freeze([].concat(_toConsumableArray(SIZES), ['xs']));
var INPUT_COLORS = /* #__PURE__ */Object.freeze(['success', 'warning', 'error']);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles$1 = createMemoStyles(function (theme) {
  var type = theme.type,
      spacing = theme.spacing,
      palette = theme.palette;
  return {
    wrenchLabel: function wrenchLabel(_ref) {
      var muted = _ref.muted,
          plain = _ref.plain;
      return _objectSpread(_objectSpread({
        display: 'block',
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        boxSizing: 'border-box',
        fontSize: type.fontSize.bodySm,
        padding: 0,
        margin: [0, 0, spacing[2]],
        fontWeight: type.fontWeight.medium
      }, plain && {
        fontWeight: type.fontWeight.regular,
        fontSize: type.fontSize.body
      }), muted && {
        color: palette.text.darkMuted,
        fontWeight: type.fontWeight.regular
      });
    }
  };
});
var useStyles$2 = useStyles$1;

var _excluded$1 = ["children", "htmlFor", "muted", "plain"];

var Label = function Label(_ref) {
  var children = _ref.children,
      htmlFor = _ref.htmlFor,
      muted = _ref.muted,
      plain = _ref.plain,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    theme: theme,
    muted: muted,
    plain: plain
  }),
      wrenchLabel = _useStyles.wrenchLabel;

  return /*#__PURE__*/React.createElement("label", Object.assign({
    className: wrenchLabel,
    htmlFor: htmlFor
  }, safeRest(rest)), children);
};

Label.displayName = "Label";
Label.propTypes = {
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  plain: PropTypes.bool
};
Label.defaultProps = {
  muted: false,
  plain: false
};
var Label$1 = Label;

var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
      spacing = theme.spacing,
      radius = theme.radius,
      shadow = theme.shadow,
      type = theme.type;
  var textarea = {
    fontSize: type.fontSize.body,
    paddingSm: [spacing[2]],
    paddingMd: [spacing[3]],
    paddingLg: [spacing[4]],
    borderRadius: radius.small
  };
  return {
    wrenchTextarea: function wrenchTextarea(_ref) {
      var color = _ref.color,
          size = _ref.size,
          stretched = _ref.stretched,
          disabled = _ref.disabled;

      var padding = function padding(s) {
        return {
          sm: textarea.paddingSm,
          md: textarea.paddingMd,
          lg: textarea.paddingLg
        }[s];
      };

      return {
        width: stretched && '100%',
        padding: padding(size),
        boxSizing: 'border-box',
        margin: 0,
        border: "solid 1px ".concat(color ? palette[color].main : palette.border.main),
        borderRadius: textarea.borderRadius,
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        outline: 'none',
        '-webkit-appearance': 'none',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-appearance': 'none',
        '-ms-appearance': 'none',
        appearance: 'none',
        boxShadow: 'none',
        backgroundColor: palette.background.light,
        fontSize: textarea.fontSize,
        pointerEvents: disabled && 'none',
        opacity: disabled && '0.4',
        '&:hover': {
          borderColor: color ? palette[color].main : palette.border.hover,
          boxShadow: shadow.sky
        },
        '&:focus': {
          borderColor: color ? palette[color].main : palette.border.active
        }
      };
    }
  };
});

var _excluded = ["value", "color", "label", "onBlur", "onChange", "id", "name", "stretched", "size", "disabled"];

var Textarea = function Textarea(_ref) {
  var value = _ref.value,
      color = _ref.color,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      id = _ref.id,
      name = _ref.name,
      stretched = _ref.stretched,
      size = _ref.size,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  deprecate({
    color: color
  }, 'color', 'warning', 'Textarea');

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      val = _useState2[0],
      setVal = _useState2[1]; // eslint-disable-next-line react-hooks/exhaustive-deps


  var isControlled$1 = useMemo(function () {
    return isControlled(value);
  }, []);
  var inputID = useMemo(function () {
    return id || uniqueId('textarea');
  }, [id]);
  var theme = useTheme();
  var classes = useStyles({
    color: color,
    size: size,
    stretched: stretched,
    disabled: disabled,
    theme: theme
  });

  var handleBlur = function handleBlur(e) {
    if (onBlur) onBlur(e);
  };

  var handleChange = function handleChange(e) {
    if (isControlled$1 && e.target.value !== val) {
      e.persist();
      setVal(e.target.value);
      if (onChange) onChange(e);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: inputID
  }, label) : null, /*#__PURE__*/React.createElement("textarea", Object.assign({
    className: classes.wrenchTextarea,
    id: inputID,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    value: val
  }, safeRest(rest))));
};

Textarea.propTypes = {
  /**
   * If true, input is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Identifer if Label or ariaLabel is not provided
   */
  // eslint-disable-next-line consistent-return
  id: function id(props, propName) {
    if (typeof props[propName] !== 'string' && typeof props.label !== 'string' && typeof props.ariaLabel !== 'string') {
      return new Error('Accessibility Error: If `label` or `ariaLabel` is not provided the `id` prop is required.');
    }
  },

  /**
   * Label for input
   */
  label: PropTypes.node,

  /**
   * Define name for input
   */
  name: PropTypes.string,

  /**
   * onBlur event handler
   * function(event: object) => void
   */
  onBlur: PropTypes.func,

  /**
   * onChange event handler
   * function(event: object) => void
   */
  onChange: PropTypes.func,

  /**
   * Size variants for TextArea
   */
  size: PropTypes.oneOf(SIZES),

  /**
   * If true, will fit the full width of parent container
   */
  stretched: PropTypes.bool,

  /**
   * Color variants for component
   */
  color: PropTypes.oneOf(INPUT_COLORS),

  /**
   * Pass prop value of input
   */
  value: PropTypes.node
};
Textarea.defaultProps = {
  disabled: false,
  id: undefined,
  label: undefined,
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  size: 'md',
  stretched: false,
  color: undefined,
  value: undefined
};

export { Textarea };
